import styled from 'styled-components'

const VaultSettingStyled = styled.div`
  width: 100%;

  .search-box {
    display: flex;
    /* justify-content: flex-end; */
    align-items: center;
    justify-content: end;
    gap: 20px;
    margin-bottom: 20px;
    margin-top: 20px;
  }

  .box-tabs-current-race {
    display: flex;
    margin-top: 16px;
    width: 1000px;
    justify-content: space-between;
  }
  .line__guild--gradiant {
    height: 2px;
    padding: 30px 0;
    img {
      width: 100%;
      height: 2px;
    }
  }
`

export const ButtonSyled = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  .fs-18 {
    .btn-name {
      font-size: 16px !important; 
    }
  }
`

export default VaultSettingStyled
